@if (resAsync | async) {
  <p class="works_HeadLine_vague" [dir]="frame?.rtlEnabled ? 'rtl' : 'auto'">
    <mark class="works_HeadLineMark">{{ workNavigationContext?.work?.headerTypeDisplayText }}</mark>
    {{ workNavigationContext?.work?.objectDesignation }}
    @if (workNavigationContext?.work?.street) {
      <mark class="works_HeadLineMark">{{ res.get('Works-Task-Detail-Street') }} </mark>
    }
    {{ workNavigationContext?.work?.street }}
    <mark class="works_HeadLineMark">{{ res.get('Works-Task-Detail-Work') }}</mark>
    {{ workNavigationContext?.work?.designation }}
  </p>
}
<div class="detailPage_Navigation_Buttons" fxLayout="row" [dir]="frame?.rtlEnabled ? 'rtl' : 'auto'">
  <work-navigation></work-navigation>
  <div class="task_HeadLine">
    <mark class="works_HeadLineMark taskTextPadding">{{ res.get('Works-Task-Detail-WorkStep') }}</mark>
    <span>{{ workNavigationContext?.task?.designation }}</span>
    <div fxLayout="row" fxLayout="row wrap" fxLayoutGap="10px">
      <abc-button
        stylingMode="text"
        class="navigationActionButton"
        [icon]="res.svgUrl('Save-Image')"
        [visible]="!frame.mapInfo.isReadOnly"
        [disabled]="!needForPersistence"
        (onClick)="save()"
      >
      </abc-button>
      <abc-button
        stylingMode="text"
        class="navigationActionButton"
        [icon]="res.svgUrl('Cancel-Image')"
        [visible]="!frame.mapInfo.isReadOnly"
        [disabled]="!needForPersistence"
        (onClick)="revert(); expandedElement = undefined"
      >
      </abc-button>
      <text class="works_isReadOnly" [ngStyle]="{ display: this.frame.mapInfo.isReadOnly ? 'inline' : 'none' }">
        <div>{{ res.get('Works-Task-Detail-ReadOnlyMessage') }}</div>
      </text>
    </div>
  </div>
</div>
<div id="scrollArea" class="scollDiv" [dir]="frame?.rtlEnabled ? 'rtl' : 'auto'">
  <div #messaegBoxContainer></div>
  <div #abcLoaderContainer id="abcLoaderContainer"></div>
  <div class="task_Body">
    @for (resultCategory of Object.keys(categoryDataSources); track trackById($index, resultCategory)) {
      <div class="categoryHeader">{{ resultCategory }}</div>
      <table
        class="taskDetailsTable"
        mat-table
        [dataSource]="categoryDataSources[resultCategory]"
        multiTemplateDataRows
      >
        <!-- Checkbox Column -->
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef></th>
          <td style="width: 40px" mat-cell *matCellDef="let row">
            <abc-check-box
              [disabled]="frame.mapInfo.isReadOnly"
              [value]="row.selected"
              [text]="res.get('Works-Task-Detail-WorkStepDone')"
              (onValueChanged)="onSelectionCheckboxChanged($event, row)"
              (click)="$event.stopPropagation()"
            >
            </abc-check-box>
          </td>
        </ng-container>
        <!-- Designation Column -->
        <ng-container matColumnDef="designation">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element">
            <div class="expantion-header">
              <span>{{ this.getDesignation(element) }}</span>
              <i class="dx-icon-chevrondown"></i>
            </div>
          </td>
        </ng-container>
        <!-- Expanded Detail Column -->
        <ng-container matColumnDef="expandedDetail">
          <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length" class="expandedDetailCell">
            <div
              class="detailRow"
              [@resultDetailExpand]="element === expandedElement && element.selected ? 'expanded' : 'collapsed'"
            >
              @if (element === expandedElement && element.selected) {
                @if (element === expandedElement && element.selected) {
                  <table class="expanded-result-table">
                    <tr style="vertical-align: top">
                      <div class="containerResult" fxLayout="row">
                        <!-- <td> -->
                        <div class="detailResult" fxFlex="60">
                          <div style="display: flex">
                            <abc-number-box
                              [id]="'Menge'"
                              class="quantity-number-box"
                              [disabled]="!element.selected || this.frame.mapInfo.isReadOnly"
                              [label]="
                                (element.caption ?? res.get('Works-Task-Detail-Quantity')) +
                                (expandedResult.mtResultType.IsQuantityRequired ? ' *' : '')
                              "
                              [labelMode]="'floating'"
                              [showSpinButtons]="true"
                              [step]="1"
                              [(value)]="element.quantity"
                              [ngClass]="{
                                'required-empty-quantity':
                                  expandedResult.mtResultType.IsQuantityRequired && !element.quantity,
                              }"
                              [ngStyle]="{ opacity: !element.selected ? '0.4' : '1' }"
                              [width]="'180px'"
                              [height]="'45px'"
                              [stylingMode]="'underlined'"
                              valueChangeEvent="keyup"
                            >
                            </abc-number-box>
                          </div>
                          <div fxLayout="row" class="dateTimeContainer">
                            <div class="dateHolder" fxFlex="60">
                              <abc-date-box
                                [id]="'date'"
                                [disabled]="!element.selected || this.frame.mapInfo.isReadOnly"
                                [type]="'date'"
                                [(value)]="element.date"
                                [stylingMode]="'underlined'"
                                [labelMode]="'floating'"
                                [label]="res.get('Works-Task-Detail-Date')"
                                [width]="'230px'"
                                [ngStyle]="{ opacity: !element.selected ? '0.4' : '1' }"
                                [valueChangeEvent]="'change'"
                                [showClearButton]="true"
                                [isConverted]="true"
                                [useMaskBehavior]="true"
                                [acceptCustomValue]="true"
                              >
                              </abc-date-box>
                            </div>
                            <div class="timeHolder" fxFlex="40">
                              <abc-date-box
                                [id]="'time'"
                                [disabled]="!element.selected || this.frame.mapInfo.isReadOnly"
                                [type]="'time'"
                                [(value)]="element.time"
                                [stylingMode]="'underlined'"
                                [width]="'230px'"
                                [ngStyle]="{ opacity: !element.selected ? '0.4' : '1' }"
                                [valueChangeEvent]="'input'"
                                [labelMode]="'floating'"
                                [label]="res.get('Works-Task-Detail-Time')"
                                [showClearButton]="true"
                                [acceptCustomValue]="true"
                                [isConverted]="true"
                                [useMaskBehavior]="true"
                                [applyValueMode]="'instantly'"
                              >
                              </abc-date-box>
                            </div>
                          </div>
                          <div style="padding-top: 1em">
                            <abc-text-area
                              [id]="'Beschreibung'"
                              class="descriptionTextArea"
                              [disabled]="!element.selected || this.frame.mapInfo.isReadOnly"
                              [width]="'88%'"
                              [height]="'45px'"
                              [autoResizeEnabled]="true"
                              [(value)]="element.description"
                              [ngClass]="{
                                'required-empty-description':
                                  expandedResult.mtResultType.IsDescriptionRequired && !element.description,
                              }"
                              [ngStyle]="{
                                opacity: !element.selected ? '0.4' : '1',
                                'margin-top': '10px',
                              }"
                              [stylingMode]="'underlined'"
                              [labelMode]="'floating'"
                              [label]="
                                res.get('Works-Task-Detail-Description') +
                                (expandedResult.mtResultType.IsDescriptionRequired ? ' *' : '')
                              "
                              valueChangeEvent="keyup input"
                            >
                            </abc-text-area>
                          </div>
                          <div style="padding-top: 20px">
                            <div fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="start center">
                              @if (expandedResult.taskAllowPointGeometries) {
                                <div>
                                  <abc-badge [number]="pointQuantity" [visible]="pointQuantity > 0">
                                    <abc-button
                                      class="geometry-square-btn"
                                      stylingMode="contained"
                                      [icon]="res.svgUrl('Georeference-AddPoint')"
                                      [disabled]="this.frame.mapInfo.isReadOnly"
                                      [width]="'45px'"
                                      [height]="'40px'"
                                      (onClick)="handleGeoWindow(0)"
                                    >
                                    </abc-button>
                                  </abc-badge>
                                </div>
                              }
                              @if (expandedResult.taskAllowLineGeometries) {
                                <div>
                                  <abc-badge [number]="lineQuantity" [visible]="lineQuantity > 0">
                                    <abc-button
                                      class="geometry-square-btn"
                                      stylingMode="contained"
                                      [icon]="res.svgUrl('Georeference-AddLine')"
                                      [disabled]="this.frame.mapInfo.isReadOnly"
                                      [width]="'45px'"
                                      [height]="'40px'"
                                      (onClick)="handleGeoWindow(1)"
                                    >
                                    </abc-button>
                                  </abc-badge>
                                </div>
                              }
                              @if (expandedResult.taskAllowPolygonGeometries) {
                                <div>
                                  <abc-badge [number]="polygonQuantity" [visible]="polygonQuantity > 0">
                                    <abc-button
                                      class="geometry-square-btn"
                                      stylingMode="contained"
                                      [icon]="res.svgUrl('Georeference-AddPolygon')"
                                      [disabled]="this.frame.mapInfo.isReadOnly"
                                      [width]="'45px'"
                                      [height]="'40px'"
                                      (onClick)="handleGeoWindow(2)"
                                    >
                                    </abc-button>
                                  </abc-badge>
                                </div>
                              }
                              @if (
                                expandedResult.mtResultType.IsGeometryRequired && expandedResult.taskAllowAnyGeometries
                              ) {
                                <div class="geometry-asterisk">
                                  <label>*</label>
                                </div>
                              }
                            </div>
                          </div>
                          <td style="padding-left: 10px">
                            @if (expandedResult.mtResultType.IsPhotoRequired) {
                              <abc-check-box
                                [disabled]="this.frame.mapInfo.isReadOnly"
                                class="impossible-photo-checkbox"
                                [(value)]="element.photoImpossible"
                                [text]="res.get('Works-Task-Detail-ImpossiblePhotoText')"
                              >
                              </abc-check-box>
                            }
                          </td>
                          <span
                            [ngStyle]="{
                              color: !allCurrentRequiredFieldsFilledIn() ? 'red' : 'black',
                              display: this.frame.mapInfo.isReadOnly ? 'none' : 'inline',
                            }"
                          >
                            {{
                              !allCurrentRequiredFieldsFilledIn() ? res.get('Works-Task-Detail-RequiredFieldsText') : ''
                            }}
                          </span>
                        </div>
                        <!-- </td> -->
                        <div class="imgDetail" fxFlex="40">
                          <td class="gallery-cell" rowspan="2">
                            <!-- <div *ngIf="!this.frame.mapInfo.isReadOnly; else disabledGallery"> -->
                            @if (
                              expandedResult.mtResultType.IsPhotoRequired &&
                              expandedResult.documents.length === 0 &&
                              !element.photoImpossible
                            ) {
                              <div class="requiredPhoto">
                                <span>{{ res.get('Works-Task-Detail-RequiredPhotoText') }}</span>
                              </div>
                            }
                            @if (!this.frame.mapInfo.isReadOnly) {
                              <div>
                                @if (
                                  expandedResult.mtResultType.IsPhotoRequired &&
                                  expandedResult.documents.length === 0 &&
                                  !element.photoImpossible
                                ) {
                                  <div class="requiredPhoto">
                                    <span>{{ res.get('Works-Task-Detail-RequiredPhotoText') }}</span>
                                  </div>
                                }
                                <div class="gallery-wrapper">
                                  @if (!element.photoImpossible) {
                                    <abc-media-gallery
                                      (onDataChanged)="mediaGalleryDataChanged($event)"
                                      [dataSource]="mediaDocuments"
                                      [enabled]="element.selected"
                                    >
                                    </abc-media-gallery>
                                  } @else {
                                    <div style="text-align: center; padding-top: 80px">
                                      {{ res.get('Works-Task-Detail-GalleryActivation') }}
                                    </div>
                                  }
                                </div>
                              </div>
                            } @else {
                              <div class="gallery-disabled">
                                <p>{{ res.get('Works-Task-Detail-GalleryActivation') }}</p>
                              </div>
                            }
                          </td>
                        </div>
                      </div>
                    </tr>
                  </table>
                }
              }
            </div>
          </td>
        </ng-container>
        <tr
          mat-row
          *matRowDef="let element; columns: displayedColumns"
          class="standardRow"
          [class.expandedRow]="expandedElement === element && element.selected"
          (click)="expandedElement = this.getNewExpandedElement(false, expandedElement, element)"
        ></tr>
        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="expandedDetailRow"></tr>
      </table>
    }
  </div>
</div>
